import { Children, cloneElement } from 'react';

import { Accordion, AccordionButton, AccordionItem, AccordionPanel, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { ChevronRight } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const StyledAccordionItem = styled(AccordionItem)`
  border-bottom-width: 0 !important;
  border-top-width: 0;

  button {
    padding: 0;
  }

  .chakra-collapse div {
    padding: 0;
  }
`;

export const MenuDropdownButton = ({ children, isExpanded, rightComponent, ...props }) => (
  <AccordionButton
    {...props}
    _hover={{ bg: 'surface.E6F1FD', 'p, svg': { color: 'button.blue.focus' } }}
    borderRadius="8px"
  >
    <Flex alignItems="center" p="8px 4px">
      <ChevronRight boxSize="24px" transform={isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'} />
      <TextBodyMedium py={1}>{children}</TextBodyMedium>
    </Flex>
  </AccordionButton>
);

export const MenuDropdownPanel = ({ children }) => <AccordionPanel pb={4}>{children}</AccordionPanel>;

export const MenuDropdownItem = ({ children }) => {
  const childrenArray = Children.toArray(children);

  return (
    <StyledAccordionItem>
      {({ isExpanded }) => childrenArray.map((child) => cloneElement(child, { isExpanded }))}
    </StyledAccordionItem>
  );
};

export const MenuDropdown = ({ children, ...props }) => (
  <Accordion allowMultiple allowToggle {...props}>
    {children}
  </Accordion>
);
